import { z } from 'zod';

import { ZIP_CODE_REGEX } from '@/consts/validation';

import { isBirthdateValid } from './helpers';

export const BaseEligibilityFormSchema = z.object({
  state: z
    .string({ required_error: 'Please select a state.' })
    .optional()
    .nullable(),
  zip: z
    .string()
    .optional()
    .nullable()
    .refine(
      (value) => !value || ZIP_CODE_REGEX.test(value),
      'Please enter a valid zip code.',
    ),
  birthdate: z
    .string({ required_error: 'Please enter your date of birth.' })
    .refine(
      (birthdate) => isBirthdateValid(birthdate),
      'Please enter a valid date of birth.',
    ),
  hasAcceptedTerms: z.coerce
    .boolean({
      required_error: 'Please accept the terms of service to continue.',
    })
    .refine(
      (value) => value,
      'Please accept the terms of service to continue.',
    ),
});

type Input = z.input<typeof BaseEligibilityFormSchema>;

type Output = z.output<typeof BaseEligibilityFormSchema>;

export const EligibilityFormSchema: z.ZodType<Output, z.ZodTypeDef, Input> =
  BaseEligibilityFormSchema.refine((data) => data.state || data.zip, {
    message: 'Please enter a state or zip code.',
  });

export type EligibilityForm = z.infer<typeof EligibilityFormSchema>;

export type EligibilityFormErrors = z.inferFlattenedErrors<
  typeof EligibilityFormSchema
>;
